import formatDate from 'date-fns/format';
import {
  fetchUsers,
  fetchUserTransactions,
  fetchUserAccounts
} from '../../services/API';

export const getUsers = async ({commit, dispatch}) => {
  commit('SET_FETCHING_USERS', true);
  try {
    const result = await fetchUsers();
    let users = result.data;
    users = users.map(user => {
      users.accounts = user.accounts.map(account => {
        account.createdAt = formatDate(new Date(account.createdAt), 'Do MMM YYYY');
        return account;
      });
      return user;
    });
    commit('SET_USERS', users);
    commit('SET_FETCHING_USERS', false);
    dispatch('setDashboardSummary', {summaryId: 'clients', count: users.length});
  } catch (error) {
    commit('SET_FETCHING_USERS', false);
    console.log("Error fetching users:", error);
  }
}

export const setSelectedUser = ({ state, commit, dispatch }, userId) => {
  if(!state.users)
    return;

  const user = state.users.find(user => user._id === userId);
  const name = `${user.firstName} ${user.lastName}`;
  commit('SET_SELECTED_USER', {...user, name});
  dispatch('getUserTransactions', userId);
  dispatch('getUserAccounts', userId);
}

export const unsetSelectedUser = ({ commit }) => {
  commit('SET_SELECTED_USER', null);
}

export const getUserTransactions = async ({ state, commit }, userId) => {
  if(!state.users)
    return;

  const userIndex = state.users.findIndex(user => user._id === userId);
  const user = state.users[userIndex];
  if(user.transactions !== undefined)
    return console.log("Transactions set!");

  try {
    const result = await fetchUserTransactions(userId);
    const response = result.data;
    const transactions = response.map(transaction => {
      const date = transaction.paidAt || transaction.updatedAt;
      transaction.date = formatDate(new Date(date), 'Do MMM YYYY');
      return transaction;
    });

    commit('UPDATE_USER', { index: userIndex, field: 'transactions', transactions });
    commit('UPDATE_SELECTED_USER', { field: 'transactions', transactions });
  } catch (error) {
    console.log("Error fetching user transactions:", error);

    const transactions = null;
    commit('UPDATE_USER', { index: userIndex, field: 'transactions', transactions });
    commit('UPDATE_SELECTED_USER', { field: 'transactions', transactions });
  }
}

export const getUserAccounts = async ({ state, commit }, userId) => {
  if(!state.users)
    return;

  const userIndex = state.users.findIndex(user => user._id === userId);
  const user = state.users[userIndex];
  if(user.accounts !== undefined)
    return console.log("Accounts set!");

  try {
    const result = await fetchUserAccounts(userId, 'savings');
    const accounts = result.data.map(a => {
      a.createdAt = formatDate(new Date(a.createdAt), 'Do MMM YYYY');
      return a;
    });

    commit('UPDATE_USER', { index: userIndex, field: 'accounts', accounts });
    commit('UPDATE_SELECTED_USER', { field: 'accounts', accounts });
  } catch (error) {
    console.log("Error fetching user accounts:", error);

    const accounts = null;
    commit('UPDATE_USER', { index: userIndex, field: 'accounts', accounts });
    commit('UPDATE_SELECTED_USER', { field: 'accounts', accounts });
  }
}
